import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the ambassadorsSummary state domain
 */
 export const makeSelectLanguage = () =>
 createSelector(selectAmbassadorsSummaryDomain, (state) => state.get("languages"))

export const makeSelectIsLoadingLanguage = () =>
 createSelector(selectAmbassadorsSummaryDomain, (state) =>
   state.get("isLoadingLanguage")
 )
const selectAmbassadorsSummaryDomain = (state) =>
  state.get("ambassadorsSummary", initialState)

/**
 * Other specific selectors
 */
export const makeSelectSummary = () =>
  createSelector(selectAmbassadorsSummaryDomain, (state) =>
    state.get("summary")
  )

export const makeSelectIsLoadingSummary = () =>
  createSelector(selectAmbassadorsSummaryDomain, (state) =>
    state.get("isLoadingSummary")
  )
// percentage
export const makeSelectPercentage = () =>
  createSelector(selectAmbassadorsSummaryDomain, (state) =>
    state.get("percentage")
  )
/**
 * Default selector used by AmbassadorsSummary
 */

const makeSelectAmbassadorsSummary = () =>
  createSelector(selectAmbassadorsSummaryDomain, (substate) => substate.toJS())

export default makeSelectAmbassadorsSummary
export { selectAmbassadorsSummaryDomain }
